import { Injectable } from "@angular/core";
import { LocalStorageService } from "angular-web-storage";
import { BehaviorSubject, Observable } from "rxjs";
import * as moment from "moment";
import { SourcePage } from "../widget/layout-component/layout-component.component";

@Injectable({
  providedIn: "root",
})
export class DataService {
  private mirrorName = new BehaviorSubject("New Mango Display");
  private activeMirrorDetail = new BehaviorSubject(null);
  private widgetSettingsLayout = new BehaviorSubject(null);
  private widgetData = new BehaviorSubject(null);
  private subscriptionDetails = new BehaviorSubject(null);
  private subscriptionObject = new BehaviorSubject(null);
  private subscriptionHirarchy = new BehaviorSubject(null);
  private templateList = new BehaviorSubject(null);
  private widgetsList = new BehaviorSubject(null);
  private displayCode = new BehaviorSubject(null);
  private customTemplateList = new BehaviorSubject(null);
  private addedCalendarAccountList = new BehaviorSubject(null);
  private showNotification = new BehaviorSubject<boolean | null>(null);
  private copiedWidgetsIds = new BehaviorSubject<Array<number>>(null);
  private copiedPageSource = new BehaviorSubject<SourcePage>(null);
  private linkedDisplayList = new BehaviorSubject(null);
  private isChildDisplayLinked = new BehaviorSubject<boolean | null>(null);
  private mirrorList = new BehaviorSubject<any | null>(null);

  currentsubscriptionStatus = false;
  notficiationType: NotificationType;

  constructor(private storage: LocalStorageService) {}

  setIsChildDisplayLinked(isChildDisplayLinked: boolean): void {
    this.isChildDisplayLinked.next(isChildDisplayLinked);
  }

  getIsChildDisplayLinked(): Observable<boolean | null> {
    return this.isChildDisplayLinked.asObservable();
  }

  public getCustomTemplateList(): Observable<any> {
    return this.customTemplateList.asObservable();
  }
  public setCustomTemplateList(customTemplateList: any) {
    this.customTemplateList.next(customTemplateList);
  }

  public getMirrorList(): Observable<any> {
    return this.mirrorList.asObservable();
  }
  public setMirrorList(mirrorList: any) {
    this.mirrorList.next(mirrorList);
  }

  public getLinkedDisplayList(): Observable<any> {
    return this.linkedDisplayList.asObservable();
  }
  public setLinkedDisplayList(linkedDisplayList: any) {
    this.linkedDisplayList.next(linkedDisplayList);
  }

  public getAddedCalendarAccountList(): Observable<any> {
    return this.addedCalendarAccountList.asObservable();
  }
  public setAddedCalendarAccountList(accountList: any) {
    this.addedCalendarAccountList.next(accountList);
  }

  setDisplayCode(displayCode: string) {
    this.displayCode.next(displayCode);
  }

  getDisplayCode(): Observable<string> {
    return this.displayCode.asObservable();
  }

  setCopiedWidgetsIds(widgetsIds: Array<number>) {
    this.copiedWidgetsIds.next(widgetsIds);
  }

  getCopiedWidgetsIds(): Observable<Array<number>> {
    return this.copiedWidgetsIds.asObservable();
  }

  setCopiedPageSource(pageSource: SourcePage) {
    this.copiedPageSource.next(pageSource);
  }

  getCopiedPageSource(): Observable<SourcePage> {
    return this.copiedPageSource.asObservable();
  }

  setNotification(shouldNotify: boolean): void {
    this.showNotification.next(shouldNotify);
  }

  getNotification(): Observable<boolean | null> {
    return this.showNotification.asObservable();
  }

  public getTemplateList(): Observable<any> {
    return this.templateList.asObservable();
  }

  public setTemplateList(templateList: any) {
    this.templateList.next(templateList);
  }

  public getWidgetsList(): Observable<any> {
    return this.widgetsList.asObservable();
  }
  public setWidgetsList(widgetsList: any) {
    this.widgetsList.next(widgetsList);
  }

  setSubscriptionHirarchy(subscriptionHirarchy: string) {
    this.subscriptionHirarchy.next(subscriptionHirarchy);
  }

  getSubscriptionHirarchyt(): Observable<string> {
    return this.subscriptionHirarchy.asObservable();
  }

  setSubscriptionObject(subscriptionObject: string) {
    this.subscriptionObject.next(subscriptionObject);
  }

  getSubscriptionObject(): Observable<string> {
    return this.subscriptionObject.asObservable();
  }

  setSubscriptionDetails(subscriptionDetails: string) {
    this.subscriptionDetails.next(subscriptionDetails);
  }

  getSubscriptionDetails(): Observable<string> {
    return this.subscriptionDetails.asObservable();
  }

  setMirrorName(mirrorName: string) {
    this.mirrorName.next(mirrorName);
  }

  getMirrorName(): Observable<string> {
    return this.mirrorName.asObservable();
  }

  setActiveMirrorDetails(mirror: any) {
    this.activeMirrorDetail.next(mirror);
  }

  getActiveMirrorDetails(): Observable<any> {
    return this.activeMirrorDetail.asObservable();
  }

  setWidgetData(widgetData: any) {
    this.widgetData.next(widgetData);
  }

  getWidgetData(): Observable<any> {
    return this.widgetData.asObservable();
  }

  setWidgetSettingsLayout(widgetSettingsLayout: any) {
    this.widgetSettingsLayout.next(widgetSettingsLayout);
  }

  getWidgetSettingsLayout(): Observable<any> {
    return this.widgetSettingsLayout.asObservable();
  }

  getCurrentSubscriptionStatus(): boolean {
    let subscription = this.storage.get("subscriptionObject");

    if (subscription != null && subscription != undefined) {
      let currentdate = moment.utc();
      if (subscription.expiryDate.isAfter(currentdate)) {
        this.currentsubscriptionStatus = true;
      } else {
        this.currentsubscriptionStatus = false;
      }
    }
    return this.currentsubscriptionStatus;
  }
}

export enum NotificationType {
  CopyPage,
  CopyWidget,
}
